<template>
    <div class="full-index">
        <div class="search">
            <!-- <search/> -->
            <input type="text" placeholder="Search" v-model="search">
        </div>
        <h4>Shows</h4>
        <loading v-if="fetching"/>
        <div class="table table-clickable table-zebra" v-else>
            <div class="body">
                <div
                    class="row"
                    v-for="show in showResults"
                    :key="show.id"
                    @click.prevent="goToShowDetail(show)"
                >
                    <div class="cell">
                        <img :src="image(show)" :alt="show.name" v-if="show.image">
                    </div>
                    <div class="cell">{{ show.name }}</div>
                    <div class="cell">{{ show.type }}</div>
                </div>
            </div>
        </div>
        <!-- <h4>Theaters</h4>
        <ul class="theatre-index">
            <li v-for="show in showResults" :key="show.ticker" @click.prevent="goToShowDetail(show)">
                <h2>{{ show.theatre }}</h2>
            </li>
        </ul>-->
    </div>
</template>

<script>
import api from "src/api";
import cl from "src/util/cloudinary";

export default {
    data() {
        return {
            fetching: true,
            showData: [],
            search: ""
        };
    },
    created() {
        api.get("shows").then(result => {
            this.showData = result.data;
            this.fetching = false;
        });
    },
    computed: {
        showResults() {
            return this.showData.filter(
                show =>
                    show.sort_name.indexOf(this.search.toLowerCase().trim()) >
                    -1
            );
        }
    },
    methods: {
        goToShowDetail(show) {
            this.$router.push({
                name: "showDetail",
                params: { show: show.slug }
            });
        },
        image(show) {
            if (!show.image) {
                return false;
            }

            return cl.url(show.image, {
                width: 96,
                crop: "scale",
                fetch_format: "auto"
            });
        }
    }
};
</script>
